// Аналитика игры: Яндекс.Метрика 113713309 и GA4 G-XQW24E4B35 (аккаунт
// TIPADUMA у egorov.oleg.viktorovich, счётчик Метрики — в кабинете ctr74).
//
// Подключаются ТОЛЬКО на боевом домене: стенды, vite и headless-съёмка в
// статистику не попадают. Вебвизор выключен — для WebGL-игры он бесполезен
// и тяжёл на телефоне. На остальных хостах track() — пустышка, вызывать её
// можно откуда угодно.
//
// События (в Метрике — JS-цели с теми же именами, в GA4 — события):
//   auth_success     — вошедший игрок открыл игру (один раз за вкладку)
//   game_start       — игрок в комнате: {mode: single|story|dm}
//   story_stage      — новый этап сюжета: {stage: 1..4}
//   story_victory    — книга заклинаний взята: {time_sec, kills}

const METRIKA_ID = 113713309;
const GA4_ID = "G-XQW24E4B35";
const PROD_HOST = "tipaduma.wogulgames.com";

type Params = Record<string, string | number>;

const enabled = typeof location !== "undefined" && location.hostname === PROD_HOST;

declare global {
  interface Window {
    ym?: (id: number, method: string, ...args: unknown[]) => void;
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
  }
}

function addScript(src: string): void {
  const s = document.createElement("script");
  s.async = true;
  s.src = src;
  document.head.appendChild(s);
}

export function installAnalytics(): void {
  if (!enabled) return;
  // Яндекс.Метрика: очередь вызовов до загрузки tag.js (как в их сниппете).
  const ymQ = function (...args: unknown[]): void {
    ((ymQ as unknown as { a?: unknown[] }).a ??= []).push(args);
  };
  (ymQ as unknown as { l: number }).l = Date.now();
  window.ym = window.ym ?? (ymQ as Window["ym"]);
  addScript(`https://mc.yandex.ru/metrika/tag.js?id=${METRIKA_ID}`);
  window.ym!(METRIKA_ID, "init", {
    clickmap: true, trackLinks: true, accurateTrackBounce: true, webvisor: false,
  });
  // GA4.
  window.dataLayer = window.dataLayer ?? [];
  window.gtag = function (): void {
    // gtag требует именно объект arguments.
    // eslint-disable-next-line prefer-rest-params
    window.dataLayer!.push(arguments);
  };
  window.gtag("js", new Date());
  window.gtag("config", GA4_ID);
  addScript(`https://www.googletagmanager.com/gtag/js?id=${GA4_ID}`);
}

/** Событие в обе системы; вне прода — ничего. */
export function track(name: string, params?: Params): void {
  if (!enabled) return;
  try { window.ym?.(METRIKA_ID, "reachGoal", name, params); } catch { /* */ }
  try { window.gtag?.("event", name, params ?? {}); } catch { /* */ }
}

let authTracked = false;
/** Вход: один раз за жизнь вкладки (refreshAuth зовётся много раз). */
export function trackAuthOnce(method: string): void {
  if (authTracked) return;
  authTracked = true;
  track("auth_success", { method });
}
